module.exports = __webpack_public_path__ + "img/kiwi-fruit.ac641791.png";